import { State } from "../js/enums";

import {
  ApiMocker,
  embed,
  waitForYlePlayerAvailable
} from "./playerStateTestPage-helpers";

const videoCountdown = "1-50008401";
const videoLoadingMedia = "1-50520823";
const videoSomethingWentWrong = "1-50520743";
const video1 = "1-70955996";

let apiMocker: ApiMocker;

const clearLocationLoginMocks = () => {
  apiMocker.clearMock(__LOGIN_API);
  apiMocker.clearMock(__LOCATION_API);
};

const embedBlockedVideo = async () => {
  apiMocker.mockLocationApi("US", false);
  apiMocker.mockLoginApi(false);
  await embed({
    embedId: video1,
    state: State.BLOCKED,
    text: "Video available only in Finland and user is not in Finland nor EU area."
  });
  clearLocationLoginMocks();
};

const embedIdentificationVideo = async () => {
  apiMocker.mockLocationApi("ES", true);
  apiMocker.mockLoginApi(false);
  await embed({
    embedId: video1,
    state: State.BLOCKED,
    text: "Video available only in Finland, user is in EU area, user not logged in.<br><b>Note:</b> This is mocked example. Video might not work after identification as it would in real case."
  });
  clearLocationLoginMocks();
};

const embedGoneVideo = async () => {
  apiMocker.mockPlayerApi(video1, State.GONE, {});
  await embed({
    embedId: video1,
    state: State.GONE,
    text: "Program no longer available."
  });
};

const embedPendingVOD = async () => {
  const pendingStartTime = new Date();
  pendingStartTime.setDate(pendingStartTime.getDate() + 1);
  pendingStartTime.setHours(pendingStartTime.getHours() + 2);
  apiMocker.mockPlayerApi(video1, State.PENDING_ONDEMAND, {
    start_time: pendingStartTime.toISOString()
  });
  await embed({
    embedId: video1,
    state: State.PENDING_ONDEMAND,
    text: "Ondemand video is not yet available."
  });
};

const embedPendingEvent = async () => {
  const pendingStartTime = new Date();
  pendingStartTime.setHours(pendingStartTime.getHours() + 2);
  apiMocker.mockPlayerApi(video1, State.PENDING_EVENT, {
    start_time: pendingStartTime.toISOString()
  });
  await embed({
    embedId: video1,
    state: `${State.PENDING_EVENT} (available only live)`,
    text: "The event is not yet available, the start time over 1 hour later. Event does not have ondemand recording."
  });
};

const embedPendingEventCountdown = async () => {
  const pendingStartTimeWithinHour = new Date();
  const pendingTime = 60 * 60 + 5; // 1 hour 5 seconds
  pendingStartTimeWithinHour.setSeconds(
    pendingStartTimeWithinHour.getSeconds() + pendingTime
  );
  apiMocker.mockPlayerApi(videoCountdown, State.PENDING_EVENT, {
    start_time: pendingStartTimeWithinHour.toISOString()
  });
  await embed({
    embedId: videoCountdown,
    state: State.PENDING_EVENT + " (countdown)",
    text: "The event will start within an hour. <b>The countdown starts within 5 seconds after page load</b>.<br /><b>Note:</b> This is mocked event to show the countdown component. After countdown it might not work as expected."
  });
  apiMocker.mockPlayerApi(videoCountdown, State.ONGOING_EVENT, {
    start_time: new Date().toISOString()
  });
};

const embedPendingEventLoadingMedia = async () => {
  apiMocker.mockPlayerApi(videoLoadingMedia, State.PENDING_EVENT, {
    start_time: new Date().toISOString()
  });
  await embed({
    embedId: videoLoadingMedia,
    state: State.PENDING_EVENT + " (loading media)",
    text: 'The event countdown has been ended, but the event is still on "pending_event" state and event should start an any second. In this mocked example, the view does not change!'
  });
};

const embedNotFoundVideo = async () => {
  await embed({
    embedId: "1-99999999",
    state: "Not found",
    text: "The media does not exist (player api returns 404 error)."
  });
};

const embedErrorState = async () => {
  apiMocker.mockPlayerApi(video1, State.ERROR, {});
  await embed({
    embedId: video1,
    state: State.ERROR,
    text: "Player got an error and media cannot be played."
  });
};

const embedNotAllowed = async () => {
  apiMocker.mockPlayerApi(video1, State.NOT_ALLOWED, {});
  await embed({
    embedId: video1,
    state: State.NOT_ALLOWED,
    text: "The player has been embedded outside of yle.fi domain and the selected media is not allowed to play outside yle.fi."
  });
};

const embedSomethingWentWrong = async () => {
  apiMocker.mockCdn(
    "https://ylekaodamdtest.akamaized.net/s/fhls/p/1956791/sp/195679100/serveFlavor/entryId/1_xv3nv0r9"
  );
  await embed({
    embedId: videoSomethingWentWrong,
    state: State.ONGOING_ONDEMAND + " (error during playback)",
    text: "The playback fails for some reason during playback. Play video to see the error."
  });
};

const renderPlayers = async () => {
  await waitForYlePlayerAvailable();

  apiMocker = new ApiMocker();
  await apiMocker.initialize();

  await embedBlockedVideo();
  await embedIdentificationVideo();
  await embedGoneVideo();
  await embedPendingVOD();
  await embedPendingEvent();
  await embedPendingEventCountdown();
  await embedPendingEventLoadingMedia();
  await embedNotAllowed();
  await embedNotFoundVideo();
  await embedSomethingWentWrong();
  await embedErrorState();
};

window.addEventListener("DOMContentLoaded", () => {
  const errorElem = document.getElementById(
    "service-worker-error"
  ) as HTMLOutputElement;
  if ("serviceWorker" in navigator) {
    renderPlayers();
  } else if (["local.yle.fi", "localhost"].includes(window.location.hostname)) {
    errorElem.value = "Page does not work on local.yle.fi or localhost.";
  } else {
    errorElem.value = "Failed to register service worker.";
  }
});
